export default __webpack_public_path__ + "faf14ce95521a607a84ea1ef4c2b6cc0.png";